import HTMLTemplate from './template.html'
import './styles.scss'
import User from '../../modules/user'
import { ModalComponent } from '../Modal/Modal'
import { DetailsPanel } from '../DetailsPanel/DetailsPanel'
import { getAirportsFeatureCollection } from '../../services/airport'
import { Compare } from '../Compare/Compare'
import tippy, { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css' // optional for styling
import 'tippy.js/animations/shift-away.css'
import AvsecAlertsModule from '../../modules/avsecAlerts'
import InternationalSOSAlerts from '../../modules/InternationalSOSAlerts'
import { filterInternationalSOSAlerts } from '../../services/EventsService'
import moment from 'moment'
import { AlertNotification } from '../AlertNotification/AlertNotification'
import MixPanelService from '../../services/MixPanelService'

export const MyAirports = (() => {
    const vueComponent = {
        data() {
            return {
                airportsData: [],
                watchListAirports: [],
                followedAirports: [],
                airportsFilterValue: '',
                isLoading: true,
                userAirportCodePreference: 'ICAO'
            }
        },
        mounted() {
            this.subscribeToUserSettingsChanges()
        },
        methods: {
            initialize() {
                this.update()
                this.startAlertsCountObserver()
            },
            update() {
                User.getLocalUserSettings().then(userInfo => { 
                    let watchListAirports = []
                    let airportsAlertsPromises = []

                    const InternationalSOSPromise = InternationalSOSAlerts.getModuleLatestAlerts()
                    userInfo.airportsWatchlist.forEach(airportICAO => {
                        let watchlistAirportInformation = this.airportsData.find(airport => airport.ICAO === airportICAO)

                        if (watchlistAirportInformation !== undefined) {
                            const airportAlertsPromise = AvsecAlertsModule.getModuleAirportAlertsInLast72Hours(watchlistAirportInformation.ICAO)

                            watchListAirports.push(watchlistAirportInformation)
                            airportsAlertsPromises.push(airportAlertsPromise)
                        }
                    })

                    this.followedAirports = userInfo.followedAirports

                    Promise.all(airportsAlertsPromises).then(values => {
                        for (let index = 0; index < values.length; index++) {
                            watchListAirports[index].airportAlerts = values[index]
                        }
                        this.watchListAirports = watchListAirports
                    })

                    Promise.all([InternationalSOSPromise]).then(values => {
                        watchListAirports.forEach((watchlistAirportInformation, index) => {
                            const internationalSOSAlertsPromise = filterInternationalSOSAlerts(values?.[0], [watchlistAirportInformation.Lat, watchlistAirportInformation.Lng], 100)

                            watchListAirports[index].internationalSOSAlerts = internationalSOSAlertsPromise.filter(alert => {
                                const alertDate = moment(alert.CreatedDate)
                                const todayMinus72Hours = moment().subtract(72, 'hours')
                                return alertDate.isAfter(todayMinus72Hours) ? true : false
                            });
                        })

                        this.watchListAirports = watchListAirports
                        this.isLoading = false
                    })
                })
            },
            startAlertsCountObserver() {
                const ONE_MINUTE = 1000 * 60
                window.setInterval(() => {
                    this.update()
                }, ONE_MINUTE)
            },
            subscribeToUserSettingsChanges() {
                window.setInterval(() => this.userAirportCodePreference = User.userSettings.airportCode, 2500)
            },
            showModalToAddAirport() {
                ModalComponent.$data.showWatchlistModal = true
                setTimeout(() => ModalComponent.$refs.addAirportCode.focus(), 10)
            },
            mixpanelTrackMyAirport(eventName, airportDetails) {
                MixPanelService.track(eventName, {
                    'Clicked Location': 'My Airports Tab',
                    'Airport Name': airportDetails?.Name || '',
                    'ICAO': airportDetails?.ICAO || '',
                    'IATA': airportDetails?.IATA || '',
                    'Country': airportDetails?.Country || '',
                    'Country Code': airportDetails?.Isocode3 || '',
                    'City': airportDetails?.City || ''
                })
            },
            removeFromWatchList(airportICAO, arrayIndex) {
                User.removeAirportFromUserWatchlist(airportICAO)
                const airportDetails = this.watchListAirports.find(res => res.ICAO === airportICAO)
                this.mixpanelTrackMyAirport('Remove Airport', airportDetails)
                this.watchListAirports.splice(arrayIndex, 1)
            },
            openAirport(airportDetails) {
                // Call the feature collection function to do all necessary transformations, our map is source of truth for airport basic data
                // Probably calling MapBox querySourceFeatures could be an idea https://docs.mapbox.com/mapbox-gl-js/api/map/#map#querysourcefeatures
                this.mixpanelTrackMyAirport('Details Panel View - airport', airportDetails)
                const airportFeatureCollection = getAirportsFeatureCollection([airportDetails])
                DetailsPanel.showDetailsPanel(airportFeatureCollection.features[0].properties)
            },
            compare() {
                const airportToAdd = this.watchListAirports.map(airport => airport.ICAO)
                MixPanelService.track('Page View - Compare', {
                    'Clicked Location': 'My Airports Tab',
                    'ICAO': airportToAdd.join(', '),
                    'Airports': this.watchListAirports?.map(res => {
                        return {
                            'Clicked Location': 'Details Panel',
                            'Airport Name': res?.airportName || '',
                            'ICAO': res?.icao || '',
                            'IATA': res?.iata || '',
                            'Country': res?.country || '',
                            'Country Code': res?.countryCode3 || '',
                            'City': res?.cityName || ''
                        }
                    })
                })
                Compare.addAirports(airportToAdd)
                Compare.show()
            },
            followUnFollowAirport(airport) {
                if (this.followedAirports.includes(airport.ICAO)) {
                    const existingAirportIndex = this.followedAirports.findIndex(airportICAOCode => airportICAOCode === airport.ICAO)
                    if (existingAirportIndex > -1) {
                        this.mixpanelTrackMyAirport('Unfollow Airport', airport)
                        this.followedAirports.splice(existingAirportIndex, 1)
                        this.updateUserSettings()
                    }
                } else {
                    if (this.followedAirports.indexOf(airport.ICAO) === -1) {
                        this.mixpanelTrackMyAirport('Follow Airport', airport)
                        this.followedAirports.unshift(airport.ICAO)
                        this.updateUserSettings()
                    } else {
                        window.alert('This airport is already being followed.')
                    }
                }
            },
            updateUserSettings() {
                User.getLocalUserSettings().then(userSettings => {
                    User.updateUserSettings({
                        ...userSettings,
                        followedAirports: this.followedAirports
                    })
                    setTimeout(() => {
                        AlertNotification.resetAlerts()
                    }, 2000);
                })
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-my-airports')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).use({
            install: (app) => {
                app.directive('tooltip', {
                    beforeMount(el, binding) {
                        tippy(el, {
                            content: binding.value,
                            placement: 'bottom-start',
                            animation: 'shift-away',
                            allowHTML: true,
                            trigger: 'mouseenter click focus',
                            arrow: false,
                            followCursor: true,
                            plugins: [followCursor]
                        })
                    }
                })
            }
        }).mount(DOMElement)
    }
})();